import createIcon from '../../createIcon';

/**
 * @component @name EventSeat
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCAyMUg3VjE4SDE3VjIxSDIwVjE1SDRWMjFaTTE5IDEwSDIyVjEzSDE5VjEwWk0yIDEwSDVWMTNIMlYxMFpNMTcgMTNIN1Y1QzcgMy45IDcuOSAzIDkgM0gxNUMxNi4xIDMgMTcgMy45IDE3IDVWMTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EventSeat = createIcon('EventSeat', [
  [
    'path',
    {
      d: 'M4 21H7V18H17V21H20V15H4V21ZM19 10H22V13H19V10ZM2 10H5V13H2V10ZM17 13H7V5C7 3.9 7.9 3 9 3H15C16.1 3 17 3.9 17 5V13Z',
      key: '66gn0c',
    },
  ],
]);

export default EventSeat;
